import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const WebsiteInfoPage = () => {
  // Website information data
  const websiteInfoData = [
    {
      sno: 1,
      content: "Name of NSF/Organization",
      link: "https://www.abfi.in/history",
      linkText: "http://www.abfi.in/history"
    },
    {
      sno: 2,
      content: "Date of last election held alongwith the details of the electoral college of the said election",
      link: "http://www.abfi.in/Election_2020-24-12dec.pdf",
      linkText: "www.abfi.in/Election_2020-24-12dec.pdf"
    },
    {
      sno: 3,
      content: "Details of recognition of International/Asian body.(copy of letter to be posted)",
      link: "https://www.abfi.in/international_rec_bfa",
      linkText: "http://www.abfi.in/international_rec_bfa"
    },
    {
      sno: 5,
      content: "Details of ACTC for the year",
      link: "https://www.abfi.in/pdf/ACTC-1.pdf",
      linkText: "(1) http://www.abfi.in/pdf/ACTC-1.pdf  (2) https://www.abfi.in/pdf/ACTC-2.pdf"
    },
    {
      sno: 6,
      content: "Annual Audited Accounts forv last 3 financial years along balance sheet (As audited by C.A. in CAG's Panel)",
      note: "Annual report for preceding year to be uploaded by 1st October of the current year.",
      link: "https://www.abfi.in/accounts",
      linkText: "http://www.abfi.in/accounts"
    },
    {
      sno: 8,
      content: "Copy of Valid registration certificate of the federation",
      link: "https://www.abfi.in/certificate_of_reg",
      linkText: "http://www.abfi.in/certificate_of_reg"
    },
    {
      sno: 9,
      content: "i) Constitution of the organization/NSFs.",
      link: "https://www.abfi.in/pdf/ABFI_constitution.pdf",
      linkText: "http://www.abfi.in/pdf/ABFI_constitution.pdf"
    },
    {
      sno: 10,
      content: "Affiliation criteria of State/UT/Clubs units alongwith details of voting rights of each unit.",
      link: "https://www.abfi.in/voting_rights",
      linkText: "Chapter 3 Rule 6 in ABFI constitution https://www.abfi.in/voting_rights"
    },
    {
      sno: 11,
      content: "Name of the affiliated units with their registration numbers.",
      link: "https://www.abfi.in/listof",
      linkText: "http://www.abfi.in/listof"
    },
    {
      sno: 12,
      content: "Name and contact details of President & Secretary of affiliated units.",
      link: "https://www.abfi.in/listof",
      linkText: "http://www.abfi.in/listof"
    },
    {
      sno: 13,
      content: "Details of National Championships conducted during the current calendar year.",
      link: "https://www.abfi.in/event",
      linkText: "http://www.abfi.in/event"
    },
    {
      sno: 14,
      content: "Calendar for National & Zonal championship to be held during current/next calendar year along with venue",
      link: "https://www.abfi.in/event",
      linkText: "http://www.abfi.in/event"
    },
    {
      sno: 19,
      content: "Notifying/updating the present selection committee for national athletes.",
      link: "https://www.abfi.in/committees",
      linkText: "https://www.abfi.in/committees"
    }
  ];

  // Office bearers data
  const officeBearers = {
    president: {
      name: "Mr. M N Krishnamurthy",
      address: "No 3C 910,3rd cross, 8th main HRBR layout Bengaluru 560043",
      tel: "9591110000",
      email: "krishnamurthymn19@gmail.com",
      tenure: "30 Nov. 2024"
    },
    secretary: {
      name: "Mr. Harish Kumar",
      address: "B-19, ist floor Sushant lok part 2 Sector 56 GURUGRAM 122011",
      tel: "8890029024",
      email: "abfi.secretarygeneral@gmail.com",
      tenure: "30 Nov. 2024"
    },
    treasurer: {
      name: "Dr. Dinesh Yadav",
      address: "901, metro suites society sector 4 vaishali ghaziabad (U. P)",
      tel: "9650173344",
      email: "drdineshyadav1972@gmail.com",
      tenure: "30 Nov. 2024"
    }
  };

  useEffect(() => {
    document.title = 'Website Information | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/photo-gallery">
          <div id="stick_right"></div>
        </Link>

        {/* Website Information Content */}
        <br /><br />

        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center>
                <label className="bol">Information to be hoisted by IOA &amp; NSFs</label>
              </center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Content</th>
                      <th>Links</th>
                    </tr>
                  </thead>
                  <tbody>
                    {websiteInfoData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>
                          {item.content}
                          {item.note && (
                            <>
                              <br />
                              <small>Note: {item.note}</small>
                            </>
                          )}
                        </td>
                        <td>
                          <a href={item.link} target="_blank" rel="noopener noreferrer">
                            {item.linkText}
                          </a>
                        </td>
                      </tr>
                    ))}

                    {/* Office Bearers Row */}
                    <tr>
                      <td>4</td>
                      <td>Name &amp; contact details of office bearers</td>
                      <td style={{backgroundColor: '#CCCCCC', padding: 0}}>
                        <table className="table table-striped table-bordered table-hover" style={{width: '100%', margin: 0}}>
                          <tbody>
                            <tr>
                              <td style={{backgroundColor: '#FFFFFF'}}>&nbsp;</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>President</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>Secretary</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>Treasurer</td>
                            </tr>
                            <tr>
                              <td style={{backgroundColor: '#FFFFFF'}}>Name</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.president.name}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.secretary.name}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.treasurer.name}</td>
                            </tr>
                            <tr>
                              <td style={{backgroundColor: '#FFFFFF'}}>Address</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.president.address}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.secretary.address}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.treasurer.address}</td>
                            </tr>
                            <tr>
                              <td style={{backgroundColor: '#FFFFFF'}}>Tel no.</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.president.tel}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.secretary.tel}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.treasurer.tel}</td>
                            </tr>
                            <tr>
                              <td style={{backgroundColor: '#FFFFFF'}}>Mail id</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.president.email}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.secretary.email}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.treasurer.email}</td>
                            </tr>
                            <tr>
                              <td style={{backgroundColor: '#FFFFFF'}}>Tenure Till (specify date)</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.president.tenure}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.secretary.tenure}</td>
                              <td style={{backgroundColor: '#FFFFFF'}}>{officeBearers.treasurer.tenure}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    {/* Additional Information Rows */}
                    <tr>
                      <td>7</td>
                      <td>Name and contact details of the firm which audited accounts.</td>
                      <td>
                        P.S. Nayak (M.No. 509950)<br />
                        Aasa and Associates<br />
                        Chartered Accountants FRN - 310073E<br />
                        Plot No 1149, Govind Prasad,<br />
                        Bomikhal, Bhubaneswal - 751010<br />
                        Tel: 0674, 2573915/16<br />
                        Mobile:9937042666<br />
                        Email: aasaassociates@gmail.com
                      </td>
                    </tr>

                    <tr>
                      <td>&nbsp;</td>
                      <td>ii) Copy of Memorandum/Articles of the Association</td>
                      <td>
                        Chapter 1 in ABFI constitution{' '}
                        <a href="https://www.abfi.in/pdf/ABFI_constitution.pdf" target="_blank" rel="noopener noreferrer">
                          https://www.abfi.in/pdf/ABFI_constitution.pdf
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>15</td>
                      <td>
                        Details in respect of international events abroad &amp; held in India:<br /><br />
                        (i) List of core probables and basis of their selection.<br />
                        (ii) Details of coaching camps organized including venue, dates and list of participants.<br />
                        (iii) Notification of selection criteria for such events at least 6 months in advance along with the details of time and venue for selection.<br />
                        (iv) List of the athletes selected.<br />
                        (v) Details of athletes, support personnel and other officials sent to the event along with the amount paid to them towards air fare, boarding and lodging, local transportation, daily allowance etc. This is required to be placed the website within 15 days of conclusion of the event.<br />
                        (vi) Performance criteria which formed the basis of selection, actual performance in terms of timing, distance etc. and the position obtained by each athlete/team.
                      </td>
                      <td>NA</td>
                    </tr>

                    <tr>
                      <td>16</td>
                      <td>List of I cards issued to National Athletes with Name of athlete, I card No. &amp; validity date.</td>
                      <td>NA</td>
                    </tr>

                    <tr>
                      <td>17</td>
                      <td>The details of certificate issued by the NSFs to the participants such as the name of the athlete, date of event, position obtained by the athlete etc.</td>
                      <td>NA</td>
                    </tr>

                    <tr>
                      <td>18</td>
                      <td>Action taken by the by the NSF for prevention of age fraud.</td>
                      <td>Keep record of each players along with I'd proof. Ban for 3 year on participation.</td>
                    </tr>

                    <tr>
                      <td>20</td>
                      <td>Note on efforts for having dope free sports and compliance to WADA/NADA Code along with details of cases found positive during the last calendar year and action taken thereon.</td>
                      <td>we are following strict guidelines of WADA/NADA.No case found +ve.</td>
                    </tr>

                    <tr>
                      <td>21</td>
                      <td>Details (Amount &amp; source) of funds received from other sources, including private sponsors, public sector undertakings, State Governments etc.</td>
                      <td>Did not receive any fund from other sources.</td>
                    </tr>

                    <tr>
                      <td>22</td>
                      <td>Revenue generated by the NSF on its own.</td>
                      <td>We are generating funds from our member if required along with grant from Govt for National Championship.</td>
                    </tr>

                    <tr>
                      <td>23</td>
                      <td>Date on which the website was last updated</td>
                      <td>10 Feb 2021</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default WebsiteInfoPage;